import React from 'react'

// components
import AdListadoGoogleList from './AdListadoGoogleList'
import AdListadoGooglePagination from './AdListadoGooglePagination'

const AdManager = ({ name }) => {
  switch (name) {
    case 'listado-google-list':
      return <AdListadoGoogleList />
    case 'listado-google-pagination':
      return <AdListadoGooglePagination />
    default:
      return null
  }
}

export default AdManager
